import { collectionURLPrefix, fallbackLocaleCode } from '#src/common/constants'

export const getCollectionPath = (locale = fallbackLocaleCode) =>
  collectionURLPrefix[locale] || collectionURLPrefix.default
